/**
 * 检查指定DOM元素下的组件是否有修改
 * @param dom DOM元素或元素ID
 * @returns 是否有修改
 */
export declare function isModified(dom: string | HTMLElement): boolean;
export default isModified;
